"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes", "className", "theme"];
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
      flex: '0 auto',
      marginBottom: '1rem',
      minWidth: 0
    }, theme.breakpoints.gte.tablet.portrait, {
      marginRight: '1rem',
      maxWidth: '18rem'
    }), theme.breakpoints.gte.mobile.landscape, {
      marginRight: '3rem'
    }), theme.breakpoints.gte.tablet.landscape, {
      marginRight: '4rem'
    })
  };
};
/*:: type Props = InjectSheetProvidedProps & HTMLElement;*/
var InfoBarItem = function InfoBarItem(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, props));
};
InfoBarItem.displayName = 'InfoBarItem';
var _default = exports.default = (0, _injectSheet.default)(Style)(InfoBarItem);
//# sourceMappingURL=InfoBarItem.js.map